export const SET_REPORTS_LIST_GLOBAL = 'ReportsGlobalContext.SET_REPORTS_LIST_GLOBAL';